import { render } from "./SpiritOfJapan7.vue?vue&type=template&id=031bc449&scoped=true"
import script from "./SpiritOfJapan7.vue?vue&type=script&lang=js"
export * from "./SpiritOfJapan7.vue?vue&type=script&lang=js"

import "./SpiritOfJapan7.scss?vue&type=style&index=0&id=031bc449&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031bc449"]])

export default __exports__